import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';
import axios from 'axios/index';

/**
 *
 * This component allows a checkbox component to make an ajax request to our API
 * without having to submit the form and reload the page.
 *
 */
@registerElement('ajax-checkbox')
export default class AjaxCheckboxElement extends ImpulseElement {
  /**
   * The endpoint to send the request too.
   */
  @property() src: string;

  /**
   * The boolean status of the checkbox.
   */
  @property() status: boolean;

  /**
   * JSON string of the data.
   */
  @property() data: string;

  /**
   * A boolean indicator that notifies the JS if the value must be revoked
   * or just toggled off
   */
  @property({ type: Boolean }) revokeStatus: boolean;

  /**
   * The HTML error field.
   */
  @target() error: HTMLElement;

  /**
   * The HTML checkbox element.
   */
  @target() checkbox: HTMLElement;

  /**
   * The HTML parent element.
   *
   */
  @target() parentRow: HTMLElement;

  connected() {
    super.connected();
  }

  /**
   *
   * Performs the related API call and adjusted the DOM as necessary.
   *
   * @function checkboxClicked
   * @return null
   */
  async checkboxClicked() {
    if (!(this.checkbox instanceof HTMLInputElement)) return;

    this.parentRow.classList.add('saving');

    try {
      const { status, data } = await axios.post(this.src, JSON.parse(this.data));
      if (status === 200) {
        this.checkbox.checked = data.on;
        this.status = data.on;
        if (this.revokeStatus === 'true') {
          data.on ? this.parentRow.classList.remove('revoked') : this.parentRow.classList.add('revoked');
        }
      } else {
        this.error.textContent = 'Something went wrong. Please try again later.';
      }

      this.parentRow.classList.remove('saving');
    } catch (error) {
      this.error.textContent = 'Something went wrong. Please try again later.';
      this.parentRow.classList.remove('saving');
    }
  }
}
